<template>
  <div class="upload flex flex-xy-center pl-30 pt-20 pr-30">
    <div class="flex1 tac">
      <div class="pic-box border-1-dashed border-radius-10 overflow-h" @click="showPreview">
        <img :src="cPreviewUrl" alt />
      </div>
      <div class="t-gray fz-26 pb-20 mt-20">模板预览</div>
    </div>
    <div class="flex1 tac ml-40">
      <div class="pic-box border-1-dashed border-radius-10 overflow-h">
        <van-uploader
          v-model="fileList"
          :max-count="1"
          :after-read="afterRead"
          @delete="beforeDelete"
        />
      </div>
      <div class="t-gray fz-26 pb-20 mt-20">上传图片</div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant"
import { upload } from "@/api/common"

export default {
  name: "Upload",
  props: {
    value: {
      type: String,
      default: "",
    },
    previewUrl: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      cPreviewUrl: "",
      fileList: [],
    }
  },
  beforeMount() {
    if (this.value) {
      this.fileList = [{ url: this.value }]
    }
    if (!this.previewUrl) {
      this.cPreviewUrl = require("@/assets/image/upload-preview.png")
    } else {
      this.cPreviewUrl = this.previewUrl
    }
  },
  methods: {
    showPreview() {
      ImagePreview([this.cPreviewUrl])
    },
    afterRead(file) {
      // 此时可以自行将文件上传至服务器
      file.status = "uploading"
      file.message = "上传中..."

      const param = new FormData()
      param.append("img", file.file)

      upload(param)
        .then((resp) => {
          file.status = "done"
          file.content = resp.data.url
          this.$emit("input", resp.data.url)
        })
        .catch(() => {
          file.status = "failed"
          file.message = "上传失败"
          file.content = ""
        })
      // setTimeout(() => {
      //   file.status = "done"
      //   // file.message = "上传失败"
      //   // file.content = require("@/assets/image/upload-preview.png")
      // }, 1000)
    },
    beforeDelete(file) {
      this.$emit("input", "")
    },
  },
}
</script>
<style lang="scss" scope>
.upload {
  background: #fff;
}
.pic-box {
  height: 160px;
  background: #f7f8fa;
  & > img {
    height: 100%;
  }
  .van-uploader {
    width: 100%;
  }
  .van-uploader__upload,
  .van-uploader__preview {
    margin: 0;
    width: 100%;
  }
  .van-uploader__preview-image {
    margin: 0 auto;
  }
}
</style>
